module.exports = __webpack_public_path__ + "static/img/Health_Tests.5d2e68d5.png";